import { AmzonImgURL,PrepareInlineStyle,CleanText,MyBlockWrapper } from '../../component/common'
import {MZSearchDialog} from '../../component/azsearch/azsearch'
import{UnitSize} from '../../component/fields/unitSize'
import {MdlImagePickerNew} from '../../component/MdlImagePicker'
import classnames from 'classnames';


const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
var el = wp.element.createElement;
const {Button,ButtonGroup,Dashicon, Flex, FlexItem, FlexBlock,RangeControl , TextControl, ToggleControl, CheckboxControl,  PanelBody } = wp.components;
const { InspectorControls, MediaUpload, MediaUploadCheck, RichText,PanelColorSettings } = wp.blockEditor;
const {Fragment} = wp.element
const { has} = lodash

registerBlockType('themesfirst/i2-azon-product-box', {
    title: __('Product Box i2AZON', 'themesfirst'),
    icon: 'embed-photo',
    category: 'themesfirst',
    keywords: [
        __('Product Box', 'themesfirst'),
        __('Amazon Product Box', 'themesfirst'),
        __('i2 azon', 'themesfirst'),
    ],
    attributes: {
        item_ids: {
            type: 'array',
            default: []
        },
        products: {
            type: 'array',
            default: []
        },
        block_id:{
            type: 'string',
            default: ''
        },
        useBorder : { 
            type : 'boolean',
            default: false
        },
        borderColor : {
            type: 'string',
            default: '#231f20'
        },
        paddingSize: {
            type: 'string',
        },
        fontSize:{
            type: 'number',
             default: 18
        },
        color : {
            type: 'string',
            default: '#222222'
				},
				textColor : {
					type: 'string',
					default: '#222222'
				},
        bgColor : {
            type: 'string',
            default: '#fff'
        },
        useLink:{
            type: 'boolean',
            default: true
				},
				hideButton:{
					type: 'boolean',
					default: false
			},
        customLink:{
            type: 'string',
            default: ''
        },
        btnText: {
            type: 'string',
            default : __('View On Amazon', 'themesfirst'),
        },
        
        boxBorder : { 
            type : 'object',
            default: {
                    use : true,
                    color: '#222222',
                    size: {  
                            unit: 'px',
                            val : 1
                    },
                    useRadius : true,
                    radius: {
                            unit: 'px',
                            val : 4
                    }
            }
        },  
        btnBorder : { 
            type : 'object',
            default: {
                use : true,
                color: '#222222',
                size: {  
                    unit: 'px',
                    val : 1
                },
                useRadius : true,
                radius: {
                    unit: 'px',
                    val : 4
                }
            }
        },        
        icon :{
            type : 'object',
            default: {
                cssClass : 'icofont-brand-amazon',
                size: 'icofont-md',
                color: '',
                bgColor: 'transprent'
                }
         },
         imgWrapperWidth: {
             type: 'number',
            default: 25
         },
         imgWidth: {
            type: 'number',
           default: 300
        },
        width:{
            type : 'object',
            default :{
                size: 400,
                unit: 'px',
                full : 780
            }
          },
        isHorizontal: {
            type: 'boolean',
            default: false
          },  
    },
    edit: (props) => {
        // console.log("==================================");
       //  console.log(props);

        const { attributes,clientId, attributes: {item_ids,width,imgWidth,imgWrapperWidth,hideButton,isHorizontal,btnBorder,textColor, boxBorder, block_id,icon,btnText, useLink,customLink, paddingSize,useBorder,borderColor, products,custom_img, link, text, color, bgColor}, setAttributes } = props;

        if(block_id == '' || block_id == undefined){
					setAttributes({block_id : clientId});
        }
				
        const updateData = (obj) => {
           // console.log(obj);
           if(has(obj, 'item_ids')){
				setAttributes(obj)
           }else{

            if(obj.products.length == 1){
              //  const features = JSON.parse(obj.products[0].features).map(x => '<li>' + CleanText(x) +'</li>' );
                const features = JSON.parse(obj.products[0].features).map(x => CleanText(x));
               // const feature = JSON.parse(obj.products[0].features).join("</li><li>");
                // console.log('=========================');
                // console.log(features);
                // console.log('=========================');
                setAttributes({products : [
                    {
                     asin : obj.products[0].asin,
                     title : obj.products[0].title, 
                     description : '',
                     features : '<li>' + features.join("</li><li>") + '</li>',                     
                   //  features :  features,                     
                   //dbFeatures : JSON.parse(obj.products[0].features),
                     dbFeatures : features,
                     image : obj.products[0].image
                }]});
            }
           }
		}
				

		const updateImages = (prodPos, image) => {

        const obj = [... products];
			obj[prodPos]['image'] = image;
			setAttributes({ products: obj })

		}
		const updateCustomImage = (pos, val) => {
			// console.log(pos)
			// console.log(val)
			const obj = [... products];
		//console.log(obj[pos]);
	//	obj[pos]['mytest'] = val;

		obj[pos]['custom_img']= val;
	//	console.log(obj[pos]);
		// obj[pos]['customImg']["mediaUrl"] = val.mediaUrl;
		setAttributes({ products: obj })
	}
	const removeCustomImage = (pos)=> {
   //     console.log("inside custom");
		if(has( products[pos], 'custom_img')){
			const obj = [... products];
			delete obj[pos]['custom_img'];
			setAttributes({ products: obj });
		}
	}
		const logAttr = () => {
			// const allImages = wp.apiFetch({ path: "/i2-azon/v1/search/my keyworeds" })
			// .then((data)=>log(data));
			//log(features.filter(x=>x.visiable).map(x=> x.id));
			console.log(attributes);
        }
				
				const updateValue = (obj) => {
					setAttributes(obj);
            }
						
            const updateProduct = (content, pos, prop, propPos) => {
                    const obj = [... products];
                    if(propPos >= 0){
                    //   console.log('inside featues', propPos );
                    obj[pos][prop][propPos]= content; 
                    }else{
                      //  console.log('inside nor', propPos );
                        obj[pos][prop]= content; 
                    }
                    setAttributes({ products: obj });
            }

            // const updateFeatureCount = (val) => {
            //     console.log(val);
            //     if(products && products.length > 0){
            //         const obj = [... products];
            //         if(obj[0].features?.length < val){
            //             for(var i = obj[0].features.length; i < val; i++){
            //                 obj[0].features[i] = obj[0].dbFeatures?.length >= i ? obj[0].dbFeatures[i] :  ''; 
            //             }
            //         }else if(obj[0].features?.length > val){
            //             obj[0].features = obj[0].features.slice(0, val);
            //         }
            //         setAttributes({ products: obj });
            //     }
            // }

            const resetFeatures=() =>{
                if(products && products.length > 0){
                 const obj = [... products];
                // const features = obj[0].dbFeatures.map(x => CleanText(x) );
                // const feature = obj[0].dbFeatures.map(x => '<li>' + x +'</li>' );
              //   obj[0]['features'] = [... obj[0].dbFeatures];
             // obj[0]['features'] = '<li>' + feature +'</li>';
                obj[0]['features'] = '<li>' + obj[0].dbFeatures.join("</li><li>") + '</li>';

                // console.log(obj);

                 setAttributes({ products: obj });
                }
            }

 		return (<>
            <InspectorControls>
            <PanelBody title = { __("Common", 'themesfirst') }
            initialOpen = { true } >
            {/* <Button onClick = { logAttr } > Log Attr </Button> */}
            <MZSearchDialog item_ids = {item_ids} products = {products} updateValue ={updateData} isSingle={true} />
			<hr /> 
			{item_ids.length > 0 &&	<h4>{__('ASIN', 'themesfirst')} : {item_ids[0]} </h4>}
            {products && products.length > 0 && 
            				<Flex>
                            <FlexBlock>Features
                    		</FlexBlock>
                            <FlexItem style={{alignSelf: 'flex-end'}}>
                            <Button style={{marginBottom: '12px', height: '30px' }} isSecondary onClick = {()=> resetFeatures()} > {__('Reset', 'themesfirst') + ' (' + products[0].dbFeatures?.length + ')'} </Button> 
                            </FlexItem>
				</Flex>
                    }
                <hr />  
                    <ButtonGroup style={{textAlign:'right', width: '100%', marginBottom: '10px'}}>
                    <Button isPrimary={isHorizontal} isSmall isSecondary={!isHorizontal} onClick={()=>setAttributes({isHorizontal : true})}><Dashicon icon="menu-alt" /> &nbsp; {__('Horizontal', 'themesfirst')}</Button>
                    <Button  isPrimary={!isHorizontal} isSmall isSecondary={isHorizontal} onClick={()=>setAttributes({isHorizontal : false})}><Dashicon icon="columns" /> &nbsp; {__('Verticle', 'themesfirst')}</Button>
                    </ButtonGroup>
                    {isHorizontal && <RangeControl
						label={  'Image Width (' + imgWidth + 'px)' } 
                        withInputField = {true}
                        allowReset = {false}
						value={ imgWidth }
						onChange={ ( obj ) => setAttributes( { imgWidth: obj})}
						min={100}	
						step ={10}			
						max={products[0]?.image?.Width > 200? products[0]?.image?.Width : 500}  
					/>}
                    {!isHorizontal && <RangeControl
						label={  'Image Area (' + imgWrapperWidth + '%)' } 
                        withInputField = {true}
                        allowReset = {false}
						value={ imgWrapperWidth }
						onChange={ ( obj ) => setAttributes( { imgWrapperWidth: obj})}
						min={15}	
						step ={1}			
						max={50}  
					/>}
                    
            <hr />    
            <ToggleControl  label= {__("Without Links?", 'themesfirst')}
                                            checked={ !useLink }
                                            onChange={ () => setAttributes({ useLink: ! useLink } )}
                                            />  
                            {useLink && <TextControl
                                            label={__("URL (By default amazon link)", 'themesfirst')}
                                            help ={__("Optional (custom url should start with http)", 'themesfirst')}
                                            value={ customLink }
                                            onChange={ (val) => setAttributes( { customLink: val})}
                                        />}    
						{useLink && <ToggleControl  label= {__("Hide Button?", 'themesfirst')}
                                            checked={ hideButton }
                                            onChange={ () => setAttributes({ hideButton: ! hideButton } )}
                                            />}  																				        
            </PanelBody>
						<PanelBody title = { __("Border Setting") } initialOpen = { false } >
									<CheckboxControl
                        label="Use Box Border?"
                        help="if you want to use border"
                        checked={ boxBorder.use }
                        onChange={ (val) => setAttributes( {boxBorder : { ...boxBorder, use: val}})}
                    />
                  {boxBorder.use &&  <Fragment>   
										<UnitSize field={boxBorder.size} min={0} max={20} label="Size" units={['px']} onChange={(val)=>setAttributes({boxBorder : { ...boxBorder, size: val}})} /> 
                    <CheckboxControl
                        label="Use Custom Radius?"
                        help="if you want to use custom radius"
                        checked={ boxBorder.useRadius }
                        onChange={ (val) => setAttributes( {boxBorder : { ...boxBorder, useRadius : val}})}
                    />                                      
                    {boxBorder.useRadius && <UnitSize field={boxBorder.radius} min={0} max={50} label="Radius" units={['%', 'px']} onChange={(val)=>setAttributes({boxBorder : { ...boxBorder, radius: val}})} />}                                   
                    </Fragment>}
                    </PanelBody> 

            {/* <PanelBody title = { __("Font Size", 'themesfirst') }
            initialOpen = { false } >
           <FontSizePicker
            fontSizes={ FontSizeList }
            value={ fontSize }
            fallbackFontSize={ 18 }
            withSlider = {true}
            onChange={ ( newFontSize ) => {
                setAttributes( { fontSize: newFontSize? newFontSize : 18 } );
            } }
            />
            </PanelBody> */}
            <PanelColorSettings
                    title={ __( 'Color Settings' , 'themesfirst') }
                    initialOpen = { false }
									 // colorSettings={colors}
									 colorSettings = { boxBorder.use? [
											{
													value: bgColor,
													onChange: ( colorValue ) => setAttributes( { bgColor: colorValue !== undefined ? colorValue : '#fff' } ),
													label: __( 'Background Color' ,'themesfirst'),
											},						
											{
												value: color,
												onChange: ( colorValue ) => setAttributes( { color: colorValue !== undefined ? colorValue : '#222222' } ),
												label: __( 'Heading Color','themesfirst' ),
											},						
											{
												value: textColor,
												onChange: ( colorValue ) => setAttributes( { textColor: colorValue !== undefined ? colorValue : '#222222' } ),
												label: __( 'Text Color','themesfirst' ),
											}	,
											{ 
													value: boxBorder.color,
													onChange: ( colorValue ) => setAttributes( { boxBorder : { ...boxBorder, color: colorValue !== undefined ? colorValue : '#222222'}} ),
													label: __( 'Border Color','themesfirst' ),
											}						
										] : [
											{
													value: bgColor,
													onChange: ( colorValue ) => setAttributes( { bgColor: colorValue !== undefined ? colorValue : '#fff' } ),
													label: __( 'Background Color' ,'themesfirst'),
											},						
											{
													value: color,
													onChange: ( colorValue ) => setAttributes( { color: colorValue !== undefined ? colorValue : '#222222' } ),
													label: __( 'Heading Color','themesfirst' ),
											},						
											{
													value: textColor,
													onChange: ( colorValue ) => setAttributes( { textColor: colorValue !== undefined ? colorValue : '#222222' } ),
													label: __( 'Text Color','themesfirst' ),
											}			

										]}
                >
        </PanelColorSettings>
            </InspectorControls>

            <figure className="tf-i2">
                 {products.length == 0 && <MZSearchDialog item_ids = {item_ids} products = {products} updateValue ={updateData} isSingle={true} />}
                {products.map((prod, j) => {return(
				  <div className={classnames({"has-border" : useBorder}, "tf-i2-product", {"tf-i2-horizontal" : isHorizontal})} style = {PrepareInlineStyle({border: boxBorder, bgColor : bgColor})}>
					<div className={"tf-i2-image"} style={{width: isHorizontal? '100%' : imgWrapperWidth + "%"}}>
                    {!has(prod, 'custom_img.mediaId') && (
					 <MdlImagePickerNew image={prod['image']} asin={prod['asin']}  prodPos={j} updateImages = { updateImages } size={isHorizontal? imgWidth : width.unit != 'px' ? null : width.size} />)}
                    <div className={prod['custom_img'] == undefined || prod['custom_img'] == ""? "no-custom-image" : "editor-post-featured-image"}>
                    {prod['custom_img'] != undefined &&  <img src={prod['custom_img'].mediaUrl} />}                        
                    <MediaUploadCheck>
                        <MediaUpload onSelect={obj=> updateCustomImage(j, {mediaId : obj.id, mediaUrl : obj.url})}
                            value={prod['custom_img'] != undefined && prod['custom_img'] != ""? prod['custom_img'].mediaId : ""}
                            allowedTypes={ ['image'] }
                            render={({open}) => (
                                <Button icon="wordpress" isSecondary size="24" className="no-custom-image" onClick={open}>                                    
                                </Button>
                            )}
                        />
                    </MediaUploadCheck>
                    {has(prod, 'custom_img.mediaId') && <Button icon="trash" className="clear-custom-image" iconSize="24" label ="Delete" onClick = {() => removeCustomImage(j)}></Button>}
                  </div>
				</div>
                	<div className="tf-i2-content" style={{width: isHorizontal? '100%' : (100 - imgWrapperWidth) + "%"}}>
					 <RichText onChange={obj=>updateProduct(obj,j, 'title', -1)}
                            tagName="h5"
														className="tf-i2-title"
														style={{color: color}}
														value={prod.title}
														formattingControls={['italic']}
                            />
                            <RichText onChange={obj=>updateProduct(obj, j , 'features', -1)}
                            tagName="ul"
                            multiline= 'li'
                            className="tf-i2-features"
                            value={prod.features}
                            style={{margin: 0, color: textColor}}
                            />
                   {useLink && !hideButton && <span className={ classnames('tf-btn-wrapper', 'tf-btn', { "tf-button-has-border" : btnBorder.use})}  style = {PrepareInlineStyle({border: btnBorder})}><i className={classnames(icon?.cssClass)}></i>           
                   <RichText onChange={obj=>setAttributes({btnText:obj})}
                    formattingControls={ [ 'bold', 'italic' ] }
                    tagName="span"
                    value={btnText}
                    />
                    </span>}
					</div>

                </div>                
                )})}             
               </figure>
            </>
        )
    },
    save: (props) => {
        const { attributes: {item_ids,width,btnBorder,boxBorder,useBorder,hideButton, block_id,icon,btnText,imgWrapperWidth,imgWidth, useLink, products,textColor, color, bgColor, isHorizontal}} = props;
        const prod = products[0];
				return (prod &&
            <div className="tf-i2" id={block_id}>
							
                <div className={classnames({"has-border" : useBorder}, "tf-i2-product", {"tf-i2-horizontal" : isHorizontal})} style={PrepareInlineStyle({border:boxBorder, bgColor: bgColor })}>
                <div className={"tf-i2-image"} style={{width: isHorizontal? '100%' : imgWrapperWidth + "%", minHeight: isHorizontal && prod['image'].Height > 0 && prod['image'].Width > 0 ? ( prod['image'].Height / prod['image'].Width * imgWidth) + "px"   : 'auto' }}>
								<MyBlockWrapper isLink={useLink} href="##AFFILIATELINK##" target="_blank" rel="nofollow noopener noreferrer">
								{!has(prod, 'custom_img.mediaId') &&								
								<img src={AmzonImgURL(prod['image'].URL, (isHorizontal? imgWidth : width.unit == "px" && width.size <= prod['image'].Width? width.size : ""),  prod['image'].EXT)} alt={prod.title} height={prod['image'].Height} width={prod['image'].Width} />
								}
								{has(prod, 'custom_img.mediaId') &&<img src={prod['custom_img']['mediaUrl']}  alt={prod.title}/>}
								</MyBlockWrapper>
                </div>
                <div className="tf-i2-content" style={{width: isHorizontal? '100%' : (100 - imgWrapperWidth) + "%"}}>								
                    <RichText.Content href="##AFFILIATELINK##" style={{color:color}} target = "_blank" className="tf-i2-title" tagName={useLink ? "a" : "span"} value={prod.title} rel = "nofollow noopener noreferrer" />
                    <RichText.Content tagName="ul" value={prod.features} style={{color: textColor}} className="tf-i2-features" />
                    {useLink && !hideButton && <a 
                     href="##AFFILIATELINK##" target = "_blank" rel = "nofollow noopener noreferrer"
                    className={ classnames('tf-btn-wrapper', 'tf-btn', { "tf-button-has-border" : btnBorder.use})} 
                     style = {PrepareInlineStyle({border: btnBorder})}>
                         <i className={classnames(icon?.cssClass)}></i>  {btnText}         
                    </a>}
                </div>
                </div>
            </div>
        )
    }
});
